<template>
  <div>
    <p class="h1">
      <b-icon
        icon="file-arrow-up-fill"
        v-b-modal.modal-photos
        scale="1"
        shift-v="0"
        shift-h="0"
        class="position-absolute"
        style="top: 25; right: 25"
      >
      </b-icon>
    </p>
    <b-modal
      id="modal-photos"
      centered
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <b-form-file
        class="form-control"
        type="file"
        @change="onFileChange"
        v-model="file"
        plain
      ></b-form-file>
      <camera-man v-on:photoTaken="getPhoto" />
      <img class="mt-3" id="uploaded-image" v-if="url" :src="url" alt="img" />
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
import CameraMan from "@/components/CameraMan";

export default {
  name: "PhotoModal",
  props: {
    trainer: Boolean,
    client: Boolean,
    clientId: Number,
  },
  components: {
    CameraMan,
  },
  data: function () {
    return {
      file: null,
      url: null,
    };
  },
  computed: {
    ...mapState(["current_client"]),
  },
  methods: {
    ...mapActions(["logOutUser"]),
    onFileChange(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);
    },
    async getPhoto(photo) {
      this.file = photo;
      await this.handleOk();
    },
    async handleOk() {
      console.log(this.file);
      let formData = new FormData();
      formData.append("file", this.file);
      if (this.client) {
        formData.append("client_id", this.clientId.toString());
        await axios
          .post(`${process.env.VUE_APP_API}/clients/photo`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${this.$cookie.get("access_token")}`,
            },
          })
          .then((response) => {
            console.log(response.data);
            this.$emit("newPic");
          })
          .catch((err) => {
            if (err.response.status === 401) {
              this.logOutUser();
            }
          });
      } else if (this.trainer) {
        formData.append("trainer_id", this.trainer);
        await axios
          .post(`${process.env.VUE_APP_API}/trainers/photo`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${this.$cookie.get("access_token")}`,
            },
          })
          .catch((err) => {
            if (err.response.status === 401) {
              this.logOutUser();
            }
          });
      }
      this.url = null;
      this.$nextTick(() => {
        this.$bvModal.hide("modal-photos");
      });
      // window.location.reload()
    },

    resetModal() {
      this.file = null;
      this.url = null;
    },
  },
};
</script>

<style scoped>
#uploaded-image {
  max-width: 100%;
  max-height: 500px;
}
</style>
